export default __webpack_public_path__ + "static/media/N_Neve.5cc06a41.svg";